import { FlatList } from 'react-native';
import styled from 'styled-components/native';

import Separator from '@src/components/Separator';
import {
  idKeyExtractor,
  maxWidth,
  padding,
} from '@src/configuration/constants';
import { Discount } from '@src/types';

export const List = styled(FlatList as new () => FlatList<Discount>).attrs(
  () => ({
    removeClippedSubviews: true,
    scrollEventThrottle: 16,
    keyExtractor: idKeyExtractor,
    ItemSeparatorComponent: Separator,
    contentContainerStyle: {
      paddingBottom: padding,
      maxWidth: maxWidth,
      marginHorizontal: 'auto',
    },
  })
)``;

export const Heading = styled.View`
  align-items: center;
`;
